<script>
export default {
  props: {
    filename: {
      type: String,
      default: '',
    },
  },

  computed: {
    apiURL() {
      return process.env.NODE_ENV === 'development'
        ? 'http://localhost:8000'
        : 'https://api.sistema.niekienovaikai.lt'
    },

    avatarURL() {
      if (!this.filename) {
        return require('@assets/images/profile.png')
      }

      return `${this.apiURL}${this.filename}`
    },
  },
}
</script>

<template>
  <div
    class="rounded-full mx-auto border border-gray-600 bg-no-repeat bg-center bg-cover"
    :style="`background-image: url('${avatarURL}')`"
  >
  </div>
</template>
